<template>
  <div class="content">
    <!-- <div class="header">
      <div
        v-for="(item,index) in labledata"
        :key="index"
        :class="{heightlight : lableindex==index}"
        @click="lableArea(index,item)"
      >
        {{item}}
        <div v-if="lableindex==index" class="xian"></div>
      </div>
    </div>-->
    <div class="metter" v-if="collectData.length!==0">
      <div v-for="(item,index) in collectData" :key="index">
        <div class="nav" v-if="item.objtype==1">
          <!-- 资源 -->
          <div class="videoBox">
            <div class="videoBoximg">
              <div>
                <img
                  :src="item.imgUrl"
                  alt
                  @click="videolearn(item.objid)"
                  style="width:120px;height:80px;cursor: pointer;"
                />
              </div>
            </div>
            <div class="videoData">
              <div class="videoDatatop">
                <span @click="videolearn(item.objid)" style="cursor: pointer;">{{item.name}}</span>
              </div>
              <div class="videoDatacenter">
                <span>警种：{{item.jzName}}</span>
                <span></span>
                <span>来源：{{item.deptName}}</span>
                <span></span>
                <span>发布：{{item.createtime}}</span>
              </div>
            </div>
            <div class="videoAppraise">
              <el-button type="danger" size="mini" plain @click="deletecollect(1,item.objid)">取消收藏</el-button>
            </div>
          </div>
        </div>
        <div class="nav" v-else-if="item.objtype==2">
          <!-- 课程 -->
          <div class="videoBox">
            <div class="videoBoximg">
              <div>
                <img
                  src="@/assets/personCenter/u6094_mouseOver.svg"
                  alt
                  style="width:140px;height:80px"
                />
              </div>
            </div>
            <div class="videoData">
              <div class="videoDatatop">
                <span @click="videolearn(index)" style="cursor: pointer;">警察影像</span>
              </div>
              <div class="videoDatacenter">课程性质：教育部高等法学专业本科教育的核心主干课程课程面向：法学专业学生及对刑事诉讼...</div>
            </div>
            <div class="videoAppraise">
              <el-button type="danger" size="mini" plain>取消收藏</el-button>
            </div>
          </div>
        </div>
        <div class="nav2" v-else-if="item.objtype==3">
          <div class="navfirst">
            <div>
              <span>心得</span>
              三种距离射击法
            </div>
            <div>
              <el-button type="danger" size="mini" plain>取消收藏</el-button>
            </div>
          </div>
          <hr />
          <div class="navsecond">
            <p>
              1月7日，召开党委（扩大）会议，传达学习习近平总书记在中央经济工作会议、
              中央农村工作会议、中央全面深化改革委员会第十七次会议、全国政协新年茶话会上的重要讲话精神
              和二〇二一年新年贺词，副省长、党委书记、厅长任军号主持会议并讲话，强调要认真学习贯彻习近平总书记重要讲话精神1月7日，云南召开党委（扩大）会议，传达学习习近平总书记在中央经济工作会议、
              中央农村工作会议、中央全面深化改革委员会第十七次会议、全国政协新年茶话会上的重要讲话精神
              和二〇二一年新年贺词，副省长、党委书记、厅长任军号主持会议并讲话，强调要认真学习贯彻习近平总书记重要讲话精神
            </p>
          </div>
          <hr />
          <div class="navthirt">
            <div>
              <span>
                <img src="@/assets/resource/u231.svg" alt />
              </span>
              <span>
                <span style="font-size='14px'">222</span>
              </span>
              <span>
                <img src="@/assets/resource/u234.svg" alt />
              </span>
              <span>222</span>

              <span>
                <img src="@/assets/resource/点赞03_u2863.svg" alt />
              </span>
              <span>22</span>
            </div>
            <div style="margin-right:10px;margin-top:2px;font-size:16px">2020-06-23 12:30:05</div>
          </div>
        </div>
        <div class="nav2" v-else-if="item.objtype==4">
          <div class="navfirst">
            <div>
              <span style="background-color:#c280fffe">教案</span>
              三种距离射击法
            </div>
            <div>
              <el-button type="danger" size="mini" plain>取消收藏</el-button>
            </div>
          </div>
          <hr />
          <div class="navsecond">
            <p>
              1月7日，召开党委（扩大）会议，传达学习习近平总书记在中央经济工作会议、
              中央农村工作会议、中央全面深化改革委员会第十七次会议、全国政协新年茶话会上的重要讲话精神
              和二〇二一年新年贺词，副省长、党委书记、厅长任军号主持会议并讲话，强调要认真学习贯彻习近平总书记重要讲话精神1月7日，召开党委（扩大）会议，传达学习习近平总书记在中央经济工作会议、
              中央农村工作会议、中央全面深化改革委员会第十七次会议、全国政协新年茶话会上的重要讲话精神
              和二〇二一年新年贺词，副省长、党委书记、厅长任军号主持会议并讲话，强调要认真学习贯彻习近平总书记重要讲话精神
            </p>
          </div>
          <hr />
          <div class="navthirt">
            <div>
              <span>
                <img src="@/assets/resource/u231.svg" alt />
              </span>
              <span>
                <span style="font-size='14px'">222</span>
              </span>
              <span>
                <img src="@/assets/resource/u234.svg" alt />
              </span>
              <span>222</span>

              <span>
                <img src="@/assets/resource/点赞03_u2863.svg" alt />
              </span>
              <span>22</span>
            </div>
            <div style="margin-right:10px;margin-top:2px;font-size:16px">2020-06-23 12:30:05</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else style="margin-top:20px">
      <nodata></nodata>
    </div>
    <div class="pagination">
      <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuerys.page"
        :page-size="listQuerys.limit"
        layout=" total,prev, pager, next,jumper"
        :total="count"
        v-if="count>0"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import * as educat from '@/api/personcenter/index.js';
export default {
  data() {
    return {
      labledata: ['全部', '资源', '课程', '教官博客', '经典教案'],
      currentPage2: 1,
      lableindex: 0,
      listQuerys: {
        page: 1,
        limit: 5,
        userId: this.$store.state.User.ids,
        type: 1,
      },
      count: 0,
      collectData: '',
    };
  },
  created() {
    this.getList();
  },
  methods: {
    lableArea(index, item) {
      this.lableindex = index;
      if (index == 0) {
        this.listQuerys.type = null;
      } else if (index == 1) {
        this.listQuerys.type = 1;
      } else if (index == 2) {
        this.listQuerys.type = 2;
      } else if (index == 3) {
        this.listQuerys.type = 3;
      } else if (index == 4) {
        this.listQuerys.type = 4;
      }
      this.getList();
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.listQuerys.limit = val;
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.listQuerys.page = val;
      this.getList();
    },
    getList() {
      educat.GetCollectionListCenter(this.listQuerys).then((res) => {
        this.collectData = res.data;
        this.count = res.count;
      });
    },
    // 点击取消收藏
    deletecollect(type, id) {
      let para = {
        objId: id,
        objType: type,
        userId: this.$store.state.User.ids,
      };
      educat.CollectionDele(para).then((res) => {
        this.$message({
          message: '取消收藏成功',
          type: 'success',
        });
        this.getList();
      });
    },
    // 跳转资源页
    videolearn(id) {
      educat.DocumentRead(id).then((res) => {});
      this.$router.push({
        path: '/sourceslist/videoLearn',
        query: {
          id: id,
        },
      });
    },
  },
};
</script>
<style scoped>
.content {
  /* width: 900px; */
  width: 100%;
  /* height: 1000px; */
  padding-bottom: 20px;
}
hr {
  margin: 1px;
  border-top: 1px solid #e2e3e6;
}
.heightlight {
  color: #409eff !important;
}
.header {
  /* width: 850px; */
  height: 35px;
  border-bottom: solid 1px #ccc;
  padding-top: 10px;
  display: flex;
}
.header > div {
  width: 100px;
  text-align: center;
  line-height: 35px;
  font-size: 16px;
  cursor: pointer;
}
.header > div:hover {
  color: #409eff;
}
.xian {
  width: 90px;
  border: solid 1px #409eff;
  margin-left: 8px;
}
.metter {
  /* display: flex; */
  flex-wrap: wrap;
}

.nav {
  width: 860px;
  height: 100px;
  /* background-color: blue; */
  margin-top: 16px;
  border-radius: 10px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 1);
  /* box-shadow: 2px 2px 5px rgba(215, 215, 215, 0.968627450980392); */
  border: solid 1px #f2f2f2;
  /* padding-left: 16px; */
  /* padding-top: 16px; */
  margin-left: 20px;
}
.nav2 {
  width: 800px;
  height: 160px;
  /* background-color: blue; */
  margin-top: 16px;
  border-radius: 10px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 1);
  box-shadow: 2px 2px 5px rgba(215, 215, 215, 0.968627450980392);
  /* padding-left: 16px; */
  /* padding-top: 16px; */
  margin-left: 20px;
}
.nav:hover,
.nav2:hover {
  box-shadow: 2px 2px 5px rgba(52, 194, 250, 0.969) !important;
}

.pagination {
  margin-top: 20px;
  text-align: center;
}
/* 循环出的视频整个盒子 */
.videoBox {
  display: flex;
  height: 100px;
}
/* 左图片区域 */
.videoBoximg {
  width: 160px;
}
.videoBoximg > div {
  width: 140px;
  height: 90px;
  margin-left: 22px;
  margin-top: 10px;
  text-align: center;
  /* box-shadow: 5px 1px 5px rgba(215, 215, 215, 0.988235294117647);
     */
}
/* 中间数据部分，样式过多 */
.videoData {
  /* width: 500px; */
  flex: 1;
  background-color: #fff;
  padding-left: 22px;
}
/* 中上 */
.videoDatatop {
  margin-top: 14px;
}
.videoDatatop > span:nth-child(1) {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  opacity: 1;
  display: inline-block;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 中中 */
.videoDatacenter {
  margin-top: 17px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.videoDatacenter > span:nth-child(1) {
  width: 126px;
  height: 14px;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: #333333;
  opacity: 1;
}
.videoDatacenter > span:nth-child(2),
.videoDatacenter > span:nth-child(4) {
  /* width: 1px; */
  /* height: 10px; */
  border: 1px solid #707070;
  opacity: 1;
  margin-left: 7px;
}
.videoDatacenter > span:nth-child(3),
.videoDatacenter > span:nth-child(5) {
  width: 104px;
  height: 14px;
  font-size: 14px;

  font-weight: 400;
  line-height: 24px;
  color: #333333;
  opacity: 1;
  margin-left: 7px;
}
/* 中下 */
.videoDatafoot {
  margin-top: 18px;
}
.videoDatafoot > span > img {
  width: 20px;
  height: 20px;
}
.videoDatafoot > span:nth-child(1) {
  width: 42px;
  height: 14px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 24px;
  color: #999999;
  opacity: 1;
  vertical-align: middle;
}
.videoDatafoot > span:nth-child(2) {
  width: 22px;
  height: 22px;
  margin-left: 5px;
  color: #7f7f7f;
}
.videoDatafoot > span:nth-child(3) {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  vertical-align: middle;
  margin-left: 35px;
}
.videoDatafoot > span:nth-child(4) {
  width: 22px;
  height: 22px;
  color: #7f7f7f;
  margin-left: 3px;
}
.videoDatafoot > span:nth-child(5) {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  vertical-align: middle;
  margin-left: 35px;
}
.videoDatafoot > span:nth-child(6) {
  width: 22px;
  height: 22px;
  color: #7f7f7f;
  margin-left: 3px;
}
.videoAppraise {
  padding-top: 20px;
  margin-right: 10px;
}
.navfirst {
  font-weight: 700;
  /* text-align: center; */
  padding: 0 36px;
  font-size: 18px;
  display: flex;
  justify-content: space-between;
}
.navfirst > div:nth-child(1) > span {
  font-weight: 500;
  padding: 5px;
  border-radius: 5px;
  font-size: 14px;
  margin-right: 10px;
  background-color: rgb(82, 104, 226);
  color: #fff;
}
hr {
  margin-top: 8px;
}
.navsecond {
  height: 70px;
  /* display: flex; */
  /* flex-wrap: wrap; */
}
.navsecond > p {
  height: 65px;
  padding: 5px 10px;
  text-indent: 2em;
  font-size: 14px;
  line-height: 24px;
  font-family: 'Arial Normal', 'Arial';
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.navthirt {
  padding-top: 5px;
  /* text-align: center; */
  padding-left: 20px;
  height: 50px;
  display: flex;
  justify-content: space-between;
}

.navthirt > div > span > img {
  width: 20px;
  height: 20px;
}
.navthirt > div > span:nth-child(1) {
  width: 42px;
  height: 14px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 24px;
  color: #999999;
  opacity: 1;
  vertical-align: middle;
}
.navthirt > div > span:nth-child(2) {
  width: 22px;
  height: 22px;
  margin-left: 5px;
  color: #7f7f7f;
}
.navthirt > div > span:nth-child(3) {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  vertical-align: middle;
  margin-left: 35px;
}
.navthirt > div > span:nth-child(4) {
  width: 22px;
  height: 22px;
  color: #7f7f7f;
  margin-left: 3px;
}
.navthirt > div > span:nth-child(5) {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  vertical-align: middle;
  margin-left: 35px;
}
.navthirt > div > span:nth-child(6) {
  width: 22px;
  height: 22px;
  color: #7f7f7f;
  margin-left: 3px;
}
</style>